import FormValidator from '@/js/plugins/formValidator'
import ImageUpload from '@/js/_components/imageUpload'

const main = () => {
    if(!document.querySelector('#page-user-register-email')) return;
    const formValidator = new FormValidator({
        renderAreaSelector: '#input-form',
        renderErrorCnt: false,
        renderErrorPosition: 'outer',
    });

    const imageUpload = new ImageUpload({
        targetSelector: '.item[data-type="image"]',
        uploadDir: 'user',
    })
}

export default main;
